export default __webpack_public_path__ + "static/media/companylogosettings.9d1c11a5.png";